const ProteinPacked = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5 9H8.5C8.22386 9 8 9.22386 8 9.5V22.5C8 22.7761 8.22386 23 8.5 23H10.5C10.7761 23 11 22.7761 11 22.5V9.5C11 9.22386 10.7761 9 10.5 9Z"
      fill="white"
    />
    <path
      d="M5.5 12H7V20H5.5C5.22386 20 5 19.7761 5 19.5V12.5C5 12.2239 5.22386 12 5.5 12Z"
      fill="white"
    />
    <path
      d="M23.5 9H21.5C21.2239 9 21 9.22386 21 9.5V22.5C21 22.7761 21.2239 23 21.5 23H23.5C23.7761 23 24 22.7761 24 22.5V9.5C24 9.22386 23.7761 9 23.5 9Z"
      fill="white"
    />
    <path
      d="M26.5 20H25V12H26.5C26.7761 12 27 12.2239 27 12.5V19.5C27 19.7761 26.7761 20 26.5 20Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 9H10.5C10.7761 9 11 9.22386 11 9.5V22.5C11 22.7761 10.7761 23 10.5 23H8.5C8.22386 23 8 22.7761 8 22.5V21V11V9.5C8 9.22386 8.22386 9 8.5 9ZM7 11V9.5C7 8.67157 7.67157 8 8.5 8H10.5C11.3284 8 12 8.67157 12 9.5V14H20V9.5C20 8.67157 20.6716 8 21.5 8H23.5C24.3284 8 25 8.67157 25 9.5V11H26.5C27.3284 11 28 11.6716 28 12.5V14.2676C28.5978 14.6134 29 15.2597 29 16C29 16.7403 28.5978 17.3866 28 17.7324V19.5C28 20.3284 27.3284 21 26.5 21H25V22.5C25 23.3284 24.3284 24 23.5 24H21.5C20.6716 24 20 23.3284 20 22.5V18H12V22.5C12 23.3284 11.3284 24 10.5 24H8.5C7.67157 24 7 23.3284 7 22.5V21H5.5C4.67157 21 4 20.3284 4 19.5V17.7324C3.4022 17.3866 3 16.7403 3 16C3 15.2597 3.4022 14.6134 4 14.2676V12.5C4 11.6716 4.67157 11 5.5 11H7ZM12 17H20V15H12V17ZM7 12H5.5C5.22386 12 5 12.2239 5 12.5V19.5C5 19.7761 5.22386 20 5.5 20H7V12ZM21.5 9H23.5C23.7761 9 24 9.22386 24 9.5V11V21V22.5C24 22.7761 23.7761 23 23.5 23H21.5C21.2239 23 21 22.7761 21 22.5V9.5C21 9.22386 21.2239 9 21.5 9ZM25 20H26.5C26.7761 20 27 19.7761 27 19.5V12.5C27 12.2239 26.7761 12 26.5 12H25V20Z"
      fill="#2B2B2B"
    />
  </svg>
);

export default ProteinPacked;
